// Componenents
import PrerenderLinks from'./components/PrerenderLinks';
import Header from'./components/Header';
import Accordion from'./components/Accordion';
import History from'./components/History';
import Slider from'./components/Slider';
import Parallax from'./components/Parallax';
import Select from'./components/Select';
import Map from'./components/Map';

// Pages
import Recruitment from'./pages/Recruitment';
import Archive from'./pages/Archive';
import Contact from'./pages/Contact';

const classes =  {
    PrerenderLinks: ['a', PrerenderLinks],
    Accordion: ['.accordion__button', Accordion],
    Header: ['.header', Header],
    History: ['.history-slider', History],
    Parallax: ['.parallax', Parallax],
    Recruitment: ['.recruitment', Recruitment],
    Slider: ['.slider', Slider],
    Select: ['select', Select],
    Archive: ['.archive-job', Archive],
    Map: ['.map-svg', Map],
    Contact: ['.contact', Contact],
};

const instances = {};

for (const element in classes) {
    if (document.querySelector(classes[element][0])) {
        const _class = classes[element][1];
        instances[element] = new _class();
    }
}